export default __webpack_public_path__ + "static/chess1-8e23fa301405046c2e7daacb455cf15b.png";